import { API } from '../Services/axios';

class HttpService {
  /**
   * Effectue une requête GET
   * @param {string} url - URL de la requête
   * @param {Object} config - Configuration de la requête
   * @returns {Promise<Object>} - Réponse de la requête
   */
  async get(url, config = {}) {
    try {
      const response = await API.get(url, config);
      return response.data;
    } catch (error) {
      console.error('Erreur GET:', error);
      throw error;
    }
  }

  /**
   * Effectue une requête POST
   * @param {string} url - URL de la requête
   * @param {Object} data - Données à envoyer
   * @param {Object} config - Configuration de la requête
   * @returns {Promise<Object>} - Réponse de la requête
   */
  async post(url, data = {}, config = {}) {
    try {
      const response = await API.post(url, data, config);
      return response.data;
    } catch (error) {
      console.error('Erreur POST:', error);
      throw error;
    }
  }

  /**
   * Effectue une requête PUT
   * @param {string} url - URL de la requête
   * @param {Object} data - Données à envoyer
   * @param {Object} config - Configuration de la requête
   * @returns {Promise<Object>} - Réponse de la requête
   */
  async put(url, data = {}, config = {}) {
    try {
      const response = await API.put(url, data, config);
      return response.data;
    } catch (error) {
      console.error('Erreur PUT:', error);
      throw error;
    }
  }

  /**
   * Effectue une requête DELETE
   * @param {string} url - URL de la requête
   * @param {Object} config - Configuration de la requête
   * @returns {Promise<Object>} - Réponse de la requête
   */
  async delete(url, config = {}) {
    try {
      const response = await API.delete(url, config);
      return response.data;
    } catch (error) {
      console.error('Erreur DELETE:', error);
      throw error;
    }
  }
}

export const httpService = new HttpService();